import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {passwordPolicy} from '../models/password-policy/password-policy';

export function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const errors: ValidationErrors = {};

        // Minimum length
        if (value.length < passwordPolicy.minLength) {
            errors['minLength'] = true;
        }

        // Minimum lowercase letters
        if ((value.match(/[a-z]/g) || []).length < passwordPolicy.minLowerCase) {
            errors['minLowerCase'] = true;
        }

        // Minimum uppercase letters
        if ((value.match(/[A-Z]/g) || []).length < passwordPolicy.minUpperCase) {
            errors['minUpperCase'] = true;
        }

        // Minimum digits
        if ((value.match(/\d/g) || []).length < passwordPolicy.minDigits) {
            errors['minDigits'] = true;
        }

        // Minimum special characters
        const specialCharactersRegex = /[!@#$%^&*(),.?":{}|<>_+\-=[\];'\\/~`]/g;
        if ((value.match(specialCharactersRegex) || []).length < passwordPolicy.minSpecialCharacters) {
            errors['minSpecialCharacters'] = true;
        }

        return Object.keys(errors).length === 0 ? null : errors;
    };
}
